import { render } from "./subject.vue?vue&type=template&id=50f6cd9f&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"

import "./subject.vue?vue&type=style&index=0&id=50f6cd9f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f6cd9f"]])

export default __exports__